import { render } from "./VotesTable.vue?vue&type=template&id=8071cc4a"
import script from "./VotesTable.vue?vue&type=script&lang=js"
export * from "./VotesTable.vue?vue&type=script&lang=js"

import "./VotesTable.vue?vue&type=style&index=0&id=8071cc4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__